import BaseContainer from "@base/container/BaseContainer"
import * as PIXI from "pixi.js";
import ScaleManager from "@/stage/ScaleManager"
import Facade from "@/Facade";
import {Signals} from "@/Imports"
import GameBackgroundContainer from "@/containers/GameBackgroundContainer";
import PlaneContainer from "@/containers/PlaneContainer";
import MultiplierContainer from "@/containers/MultiplierContainer";
import MakeBetsContainer from "@/containers/MakeBetsContainer";
import CurtainContainer from "@/containers/CurtainContainer";
import Config from "@/config/Config";
import Utils from "@base/utils/Utils";
import PlatformContainer from "./PlatformContainer";
import FeatureContainer from "./FeatureContainer";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import RewardContainer from "@/containers/RewardContainer";
import ConnectionErrorContainer from "@/containers/ConnectionErrorContainer";

export default class MainContainer extends BaseContainer {

  constructor() {
    super()
    this.isCreated = false
    Facade.mainContainer = this
    this.init()
    this.interactive = false

    Signals.continueBtnClick.add(this.onContinueBtnClick, this)
    Signals.chatVisibilityChange.add(this.onChatVisibilityChange, this)

    Signals.roundEnd.add(this.onStopFeature, this)
    Signals.stopFeature.add(this.onStopFeature, this)
    Signals.startFeature.add(this.onStartFeature, this)
    Signals.makeBets.add(this.onMakeBets, this)
    Signals.isMobileDevice.add(this.onMobileDevice, this)
  }

  init() {
    this.onOrientationChanged(Facade.orientation)

    this.generalContainer = new PIXI.Container()
    this.addChild(this.generalContainer)

    this.gameBackground = new GameBackgroundContainer()
    this.generalContainer.addChild(this.gameBackground)

    this.platformContainer = new PlatformContainer()
    this.generalContainer.addChild(this.platformContainer)

    this.danger = new SpineAnimation('warningSignAnim')
    this.generalContainer.addChild(this.danger)
    Utils.applyFromPattern(this.danger, Config.currentPattern.planeContainer)
    this.danger.x -= 400
    this.danger.y -= 40
    this.danger.visible = false

    this.featureContainer = new FeatureContainer()
    this.generalContainer.addChild(this.featureContainer)

    this.planeContainer = new PlaneContainer()
    this.generalContainer.addChild(this.planeContainer)


    this.multiplierContainer = new MultiplierContainer()
    this.planeContainer.container.addChild(this.multiplierContainer)

    this.makeBetsContainer = new MakeBetsContainer()
    this.generalContainer.addChild(this.makeBetsContainer)

    this.rewardContainer = new RewardContainer()
    this.generalContainer.addChild(this.rewardContainer)

    this.curtainContainer = new CurtainContainer()
    this.generalContainer.addChild(this.curtainContainer)

    this.connectionErrorContainer = new ConnectionErrorContainer()
    this.generalContainer.addChild(this.connectionErrorContainer)

    window.dispatchEvent(new Event('resize'))

    Signals.graphicsCreated.dispatch()

    this.setPositions()

    this.isCreated = true

  }

  onStopFeature() {
    this.danger.visible = false
    this.danger.stop()
  }

  onStartFeature() {
    this.danger.visible = true
    this.danger.start(['DangerAlex'], [true])
  }

  onMakeBets() {
  }

  onContinueBtnClick() {
    Signals.chatVisibilityChange.dispatch(true)
  }

  onChatVisibilityChange(visible) {
    Facade.rootDIV = document.getElementById('root')
    Facade.rootDIV.style.visibility = visible ? "visible" : "hidden"
  }

  onOrientationChanged(orientationSymbol) {
    switch (orientationSymbol) {
      case 'Hm':
      case 'Vm':
      case 'Hd':
        Config.currentPattern = Config.pattern.desktop
        break
        /*
                Config.currentPattern = Config.pattern.desktop
                break*!/

                Config.currentPattern = Config.pattern.desktop
                break*/
    }
    if(this.isCreated) {
      this.setPositions()
    }


  }

  setPositions() {
    //this.createGeneralMask()
    //this.createViewportMask()

    Utils.applyFromPattern(this.platformContainer, Config.currentPattern.mainMask)
    Utils.applyFromPattern(this.gameBackground, Config.currentPattern.mainMask)
    Utils.applyFromPattern(this.rewardContainer, Config.currentPattern.main)
    Utils.applyFromPattern(this.featureContainer, Config.currentPattern.main)
    Utils.applyFromPattern(this.planeContainer, Config.currentPattern.planeContainer)
    Utils.applyFromPattern(this.makeBetsContainer, Config.currentPattern.makeBetsContainer)
    Utils.applyFromPattern(this.curtainContainer, Config.currentPattern.main)

    this.featureContainer.x += 12
    this.planeContainer.x += 7
    this.platformContainer.scale.set(0.82)
    this.platformContainer.y += 275
    this.platformContainer.x -= 0
    this.gameBackground.x -= 300
    this.gameBackground.y += 180
    this.multiplierContainer.y = 90

    this.x = 0
    this.y -= 0

    switch (Facade.orientation) {
      case 'Hd':

        this.generalContainer.visible = true
        break

      case 'Hm':
        this.generalContainer.visible = false
        break

      case 'Vm':
        this.generalContainer.visible = true
        break
    }
  }

  onMobileDevice(value) {
   /* if(value) {
      this.planeContainer.scale.set(1.3)
      this.multiplierContainer.y = 85
    } else {
     this.planeContainer.scale.set(1)
      this.multiplierContainer.y = 90
    }*/
  }

  createGeneralMask() {
    if(this.generalMask) {
      this.removeChild(this.generalMask)
      this.generalMask = null
    }
    this.generalMask = new PIXI.Graphics()
    this.generalMask.beginFill(0xffffff)
    this.generalMask.drawRect(0, 0, ScaleManager.currentSizes.total.width, ScaleManager.currentSizes.total.height)
    this.generalMask.endFill()
    this.mask = this.generalMask
    this.addChild(this.generalMask)
  }
/*
  createViewportMask() {
    if(this.backMask) {
      this.removeChild(this.backMask)
      this.backMask = null
    }
    this.backMask = new PIXI.Graphics()
    this.backMask.beginFill(0xfff3ff)
    this.backMask.drawRoundedRect(Config.currentPattern.mainMask.x, Config.currentPattern.mainMask.y, Config.currentPattern.mainMask.width, Config.currentPattern.mainMask.height, 15)
    this.backMask.endFill()
    this.generalContainer.mask = this.backMask
    this.addChild(this.backMask)
  }*/



}
